import {
  useRegisteredComponent,
  type AgentStreamViewProps,
} from '../registry/PluginComponentRegistry';

export type { AgentStreamViewProps };

/**
 * Agent stream view component.
 *
 * This component requires host-specific infrastructure (hooks, contexts,
 * plugin system) and cannot be rendered in isolation. The web host must
 * provide the real implementation via `PluginComponentProvider`.
 *
 * @throws Error if the component is not registered
 */
export function AgentStreamView(props: AgentStreamViewProps) {
  const RegisteredComponent = useRegisteredComponent('AgentStreamView');
  return <RegisteredComponent {...props} />;
}
